/**
 * We'll load braintree drop-in ui for payments
 */
if (window.paymentForm = document.getElementById('payment-container')) {
     if (window.location.href.indexOf("pricing/change-payment-method") > -1 ) {
         window.dropin = require('braintree-web-drop-in');
         require('./payment-change-method.js');
    } else if (window.location.href.indexOf("pricing/pay") > -1 || window.location.href.indexOf("/pay") > -1) {
        window.dropin = require('braintree-web-drop-in');
        require('./payment-checkout.js');
    }else if (window.location.href.indexOf("pricing") > -1) {
         require('./payments-checkout-options.js');
     }
}
